import React from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {H4} from "@irati/ui/src/Headings"

import Field from "./Field"
import {RecapContainer, List} from "./styled"

const FieldsRecap = () => (
  <RecapContainer>
    <H4>
      <FormattedMessage id="admin.components.addPeopleCSV.fieldsMapping.title" />
    </H4>
    <List>
      <Field
        label="admin.components.addPeopleCSV.fieldsMapping.firstName.label"
        description="admin.components.addPeopleCSV.fieldsMapping.firstName.description" />
      <Field
        label="admin.components.addPeopleCSV.fieldsMapping.lastName.label"
        description="admin.components.addPeopleCSV.fieldsMapping.lastName.description" />
      <Field
        label="admin.components.addPeopleCSV.fieldsMapping.email.label"
        description="admin.components.addPeopleCSV.fieldsMapping.email.description" />
      <Field
        label="admin.components.addPeopleCSV.fieldsMapping.team.label"
        description="admin.components.addPeopleCSV.fieldsMapping.team.description" />
      <Field
        label="admin.components.addPeopleCSV.fieldsMapping.role.label"
        description="admin.components.addPeopleCSV.fieldsMapping.role.description" />
      <Field
        label="admin.components.addPeopleCSV.fieldsMapping.externalId.label"
        description="admin.components.addPeopleCSV.fieldsMapping.externalId.description" />
    </List>
  </RecapContainer>
)

export default FieldsRecap
